// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppPolicy {
  max-width: 800px;
  margin: 0 auto;
  padding: 32px 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: #1f2937;
}

.AppPolicy .pageTitle {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 24px;
  color: #111827;
}

.AppPolicy h2 {
  font-size: 20px;
  font-weight: 600;
  margin-top: 32px;
  margin-bottom: 12px;
  color: #374151;
}

.AppPolicy h3 {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 16px;
}

@media (max-width: 480px) {
  .AppPolicy {
    padding: 24px 16px;
  }

  .AppPolicy .pageTitle {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/AppPolicy.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wIAAwI;EACxI,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".AppPolicy {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 32px 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  color: #1f2937;\n}\n\n.AppPolicy .pageTitle {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 24px;\n  color: #111827;\n}\n\n.AppPolicy h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-top: 32px;\n  margin-bottom: 12px;\n  color: #374151;\n}\n\n.AppPolicy h3 {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #4b5563;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 480px) {\n  .AppPolicy {\n    padding: 24px 16px;\n  }\n\n  .AppPolicy .pageTitle {\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
